export const StepIconSvgs = {
  currentStepSvg: `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>Group 4</title>
        <desc>Created with Sketch.</desc>
        <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="What’s-next?_01-xs-375" transform="translate(-17.000000, -463.000000)">
                <g id="What's-next?-Copy" transform="translate(8.000000, 333.000000)">
                    <g id="System-Size" transform="translate(9.000000, 32.000000)">
                        <g id="Small">
                            <g id="Group-4" transform="translate(0.000000, 98.000000)">
                                <circle id="Oval-Copy" fill="#FFFFFF" cx="26" cy="26" r="13"></circle>
                                <circle id="Oval-Copy-2" fill="#E3E3E3" cx="26" cy="26" r="6"></circle>
                                <circle id="Oval" fill="#FFFFFF" cx="26" cy="26" r="26"></circle>
                                <circle id="Oval" stroke="#A5BB48" cx="26" cy="26" r="19"></circle>
                                <circle id="Oval" fill="#A5BB48" cx="26" cy="26" r="9"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    `,
  futureStepSvg: `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>Group</title>
        <desc>Created with Sketch.</desc>
        <g id="Designs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="What’s-next?_01-xs-375" transform="translate(-29.000000, -534.000000)">
                <g id="What's-next?-Copy" transform="translate(8.000000, 333.000000)">
                    <g id="System-Size" transform="translate(9.000000, 32.000000)">
                        <g id="Small">
                            <g id="Group" transform="translate(12.000000, 169.000000)">
                                <circle id="Oval-Copy" fill="#FFFFFF" cx="13" cy="13" r="13"></circle>
                                <circle id="Oval-Copy-2" fill="#E3E3E3" cx="13" cy="13" r="6"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    `
};
